import { createContext } from 'use-context-selector';

import { notImplemented } from 'utils/notImplemented';
import { EnrichTab } from '../EditEnrichedVacancyForm/EditEnrichedVacancy.types';
import {
  EnrichVacancyModalState,
  EnrichVacancyModalType,
  type EnrichVacancyModalContextProps,
} from './EnrichVacancyModalContext.types';

export const enrichVacancyModalContextInitialData: EnrichVacancyModalContextProps = {
  state: EnrichVacancyModalState.ChoosingCreationMethod,
  modalType: EnrichVacancyModalType.Ats,
  vacancy: null,
  editVacancyTab: EnrichTab.EnrichedVersion,

  setState: notImplemented,
  setVacancy: notImplemented,
  setEditVacancyTab: notImplemented,
};

export const EnrichVacancyModalContext = createContext(enrichVacancyModalContextInitialData);
